import React, { useMemo } from 'react';
import { ControllerRenderProps, Select } from '@otp/ui';
import { useTranslation } from 'react-i18next';
import { WttpQuestionImportance } from 'src/graphql/generated/graphql';

interface ImportanceProps {
  field: ControllerRenderProps<any, 'importance'>;
  hasError: boolean;
  className?: string;
  disabled?: boolean;
}

export const ImportanceField = ({
  field,
  hasError,
  className,
  disabled,
}: ImportanceProps) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'wttp.question',
  });

  const importanceOptions = useMemo(
    () => [
      { value: WttpQuestionImportance.Low, name: t('importance.low') },
      { value: WttpQuestionImportance.Medium, name: t('importance.medium') },
      { value: WttpQuestionImportance.High, name: t('importance.high') },
    ],
    [t],
  );

  // eslint-disable-next-line
  const defaultImportanceValue = useMemo(() => field.value, []);

  return (
    <Select
      className={className}
      options={importanceOptions}
      placeholder={t('form.importance')}
      defaultValue={defaultImportanceValue}
      error={hasError}
      {...field}
      disabled={disabled}
      value={undefined}
      ref={undefined}
      inputRef={field.ref}
    />
  );
};
